module.exports = __webpack_public_path__ + "static/media/computer-table.4fdf6d5b.jpg";